export const COT_TOOLTIP_CONTEXT_DEFAULT = "insights.changeOverTime.tooltipContext.defaultInterest"
export const COT_TOOLTIP_CONTEXT_DRIVER = "insights.changeOverTime.tooltipContext.driver"
export const COT_TOOLTIP_CONTEXT_QUESTION = "insights.changeOverTime.tooltipContext.question"
